import './learntabfooter.css';

import { ArrowBackIcon, ArrowForwardIcon, EditIcon } from '@chakra-ui/icons'
import { Box, Button, HStack, Image, } from '@chakra-ui/react'
import { useEffect, useMemo, useRef, } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { useUser } from 'src/hooks/useUser'
import { getAdminAppUrl } from 'src/util/getAdminAppUrl';

import FourLControls from './FourLControls';
import { isMobile } from './Practice/Util'
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export function LearnTabFooter({ playingProps, playerRef, isFourLVideo, editUri }) {
  const params = useParams()
  const location = useLocation()
  const history = useHistory()
  const { user: auth } = useUser()
  const divRef = useRef(null);
  const categories = useSelector(state => state.mainReducer.videoCategories);
  const [videoList, setVideoList] = useState([]);

  const {
    selectedLesson,
    courseLeftMenu,
    loading,
    loadingCourse,
  } = useSelector(store => store.mainReducer)


  // Set video list only once from matched category
  useEffect(() => {
    if (!params?.slug || !categories?.length) return;

    const matchedCategory = categories.find(category =>
      category.videos?.some(video =>
        video._id === params.slug || video.slug === params.slug
      )
    );

    if (matchedCategory) {
      setVideoList(matchedCategory.videos);
    }
  }, [categories, params?.slug]);

  // Memoized current index based on videoList and param
  const currentIndex = useMemo(() => {
    return videoList.findIndex(
      (item) => item._id === params?.slug || item.slug === params?.slug
    );
  }, [videoList, params?.slug]);

  // Get the next video (if any)
  const currentVideo = useMemo(() => {
    if (currentIndex >= 0 && currentIndex < videoList.length - 1) {
      return videoList[currentIndex + 1];
    }
    return null;
  }, [currentIndex, videoList]);

  const onEditLessonClick = () => {
    window.open(
      getAdminAppUrl() + `${editUri}`,
      '_blank'
    )
  }
  const getNextLesson = () => {
    if (selectedLesson.nextLesson) return selectedLesson.nextLesson

    const currentChapter = courseLeftMenu.chapters.find(
      item => item.chapterId === selectedLesson.chapterId
    )

    if (currentChapter) {
      const currentLessonIndex = currentChapter.lessons.findIndex(
        lesson => lesson.id === selectedLesson.lesson.id
      )

      if (currentLessonIndex > -1) {
        return currentChapter.lessons[currentLessonIndex + 1]
      }
    }

    return
  }

  const onContinueClick = () => {
    const currentLesson = selectedLesson
    const nextLesson = getNextLesson()
    if (nextLesson) {
      const url = `/introduction/course/${params.courseId}/chapter/${params.chapterId}/unit/${params.unitId}/lesson/${nextLesson.id}`
      history.push(url)
    } else {
      // checking for next chapter
      const currentChapterIndex = courseLeftMenu.chapters.findIndex(
        item => item.chapterId === currentLesson.chapterId
      )
      if (currentChapterIndex !== -1) {
        let nextChapter = courseLeftMenu.chapters[currentChapterIndex + 1]
        if (nextChapter && nextChapter.lessons) {
          const lesson = nextChapter.lessons[0] //moving the first item of next chapter
          const url = `/introduction/course/${params.courseId}/chapter/${params.chapterId}/unit/${params.unitId}/lesson/${lesson.id}`
          history.push(url)
        } else {
          history.push('/language')
        }
      } else {
        history.push('/language')
      }
    }
  }

  const onPracticeClick = () => {
    if (
      location?.pathname?.startsWith('/video') &&
      currentVideo
    ) {
      const nextSlugOrId = currentVideo.slug || currentVideo._id;
      history.push(`/video/${nextSlugOrId}`);
    } else {
      const lessonData = selectedLesson;
      if (lessonData.lesson.linkedExerciseIds.length === 0) {
        onContinueClick()
      } else {
        let url = `${history.location.pathname}/practice`
        url = url.replace('/introduction', '')
        history.push(url)
      }
    }
  }

  const onBackClick = () => {
    history.goBack();
  }

  const { isPlaying, setIsPlaying, isMuted, played } = playingProps;
  const renderPlayerControls = () => (!loadingCourse && !loading) && (
    <>
      <Image
        cursor="pointer"
        src="/icons/backward.svg"
        alt="backward"
        width="25px"
        className="backward"
        onClick={() => playerRef.current.backward()}
      />
      <Image
        cursor="pointer"
        width="35px"
        src={`/icons/${isPlaying ? 'stop.svg' : 'play.svg'}`}
        onClick={() => setIsPlaying(!isPlaying)}
        aria-label={isPlaying ? "Pause" : "Play"}
        alt="play"
        className={`play ${isPlaying ? 'playing-animation' : ''}`}
      />
      <Image
        cursor="pointer"
        width="25px"
        src="/icons/forward.svg"
        alt="forward"
        className="forward"
        onClick={() => playerRef.current.forward()}
      />
    </>
  );


  return (
    <>
      <Box className="player-progress" ref={divRef}
        width="100%"
      >
        <input
          type="range"
          className="progress-bar-fill"
          id="progress-bar"
          min="0"
          max="100"
          step="any"
          value={played}
          onMouseDown={() => playerRef.current.setSeek(true)}
          onChange={(e) => playerRef.current.handleSeekChange(e)}
          onMouseUp={() => playerRef.current.setSeek(false)}
          style={{
            width: '100%',
            height: '6px',
            borderRadius: '3px',
            background: `linear-gradient(to right, #3182CE ${played}%, #ccc ${played}%)`,
            appearance: 'none',
            outline: 'none',
            cursor: 'pointer',
          }}
        />
        <HStack
          className="inroduction-footer"
          h="70px"
          bgColor="#F2F7FF"
          position="Fixed"
          bottom="0"
          width="100%"
          zIndex={-1}
        >
          <Box
            width="1183px"
            margin="0 auto"
            justifyContent="space-between"
            display="flex"
          >
            <Button
              leftIcon={<ArrowBackIcon />}
              onClick={onBackClick}
              variant="secondary"
              size={'md'}
              width={isMobile && auth?.role !== 'ADMIN' ? '100%' : 'auto'}
              className={`classic back-button`}
              disabled={loadingCourse || loading}
            >
              Back
            </Button>
            <Box alignItems='center' margin='0 auto' gap="8px" display="flex">
              {isMobile ? renderPlayerControls() :
                <FourLControls isFourLVideo={isFourLVideo} playerRef={playerRef}> {renderPlayerControls()}</FourLControls>
              }
              {(!loadingCourse && !loading) && <Image
                cursor="pointer"
                src={`/icons/${!isMuted ? 'sound.svg' : 'mute.svg'}`}
                width="25px"
                alt="sound"
                className="sound"
                onClick={() => playerRef.current.mute()}
              />}
            </Box>
            <Button
              rightIcon={<ArrowForwardIcon />}
              onClick={onPracticeClick}
              variant="secondary"
              size={'md'}
              width={isMobile && auth?.role !== 'ADMIN' ? '100%' : 'auto'}
              className={`classic continue-button`}
              disabled={loadingCourse || loading || (location.pathname.startsWith("/video") && !currentVideo)}
            >
            { location.pathname.startsWith("/video") ?  "Next" : "Continue"}
            </Button>
            {auth?.role === 'ADMIN' && (
              <Button
                onClick={onEditLessonClick}
                rightIcon={<EditIcon />}
                className='learn-tab-footer-edit-btn'
                variant="primary"
                size={'md'}
                ml={2}
                disabled={loadingCourse || loading}
              >
                Edit
              </Button>
            )}
          </Box>
        </HStack>
      </Box>


    </>
  )
}
